import type { ContactPace, JobPost } from "../types";

function budgetLine(job: JobPost): string {
  if (typeof job.budgetMin === "number" && typeof job.budgetMax === "number") {
    return `$${job.budgetMin} to $${job.budgetMax}`;
  }

  if (typeof job.budgetMin === "number") {
    return `Starts at $${job.budgetMin}`;
  }

  return "Budget not provided";
}

export function formatJobForHandoff(job: JobPost): string {
  const scope = job.scopeItems.map((item) => `${item.category}: ${item.description}`).join("\n");
  const risks = job.riskFlags.length
    ? job.riskFlags.map((flag) => `${flag.label}: ${flag.guidance}`).join("\n")
    : "No warnings found.";

  return [
    `ClearScope job brief for ${job.title}`,
    `Job ID: ${job.id}`,
    `Location: ${job.neighborhood}, ${job.city}, ${job.state}`,
    `Desired window: ${job.desiredWindow}`,
    `Urgency: ${job.urgency}`,
    `Budget: ${budgetLine(job)}`,
    `Detail score: ${job.readiness.level} ${job.readiness.score}/100`,
    "",
    "Job details:",
    scope,
    "",
    "Safety notes:",
    risks,
    "",
    "Confirm license, insurance, materials, access, arrival window, and final price in writing.",
  ].join("\n");
}

export function buildMailto(job: JobPost, contact: ContactPace): string {
  const subject = encodeURIComponent(`ClearScope job brief: ${job.title}`);
  const body = encodeURIComponent(formatJobForHandoff(job));
  return `mailto:${encodeURIComponent(contact.primary)}?subject=${subject}&body=${body}`;
}

export function buildSms(job: JobPost, contact: ContactPace): string {
  const body = encodeURIComponent(
    `ClearScope job brief: ${job.title}. Job ID ${job.id}. Review details before commitment.`,
  );
  return `sms:${encodeURIComponent(contact.primary)}?&body=${body}`;
}
